/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'

import { InputText } from 'primereact/inputtext'
import { Password } from 'primereact/password'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

import PropTypes from 'prop-types'
import { userValidation } from '../_validation'

function LoginComponent({ user, authentication, login, forgotPassword }) {
  const [errors, setErrors] = useState({})
  const [inputs, setInputs] = useState({
    username: '',
    password: '',
    emailAddress: ''
  })
  const [isForgotDialogVisible, setIsForgotDialogVisible] = useState(false)
  const { username, password, emailAddress } = inputs

  function onChange(e) {
    const { name, value } = e.target
    setInputs(inputs => ({ ...inputs, [name]: value }))
    setErrors(userValidation.loginValidation(username, password))
  }

  function onEmailChange(e) {
    const { name, value } = e.target
    setInputs(inputs => ({ ...inputs, [name]: value }))
    setErrors(userValidation.forgotPasswordValidation(emailAddress))
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (e) {
      e.preventDefault()
      setErrors(userValidation.loginValidation(username, password))
    }
    if (username && password && errors.userName === '') {
      login(username, password)

    }
  }
  function cancelDailogheader(e) {
    setErrors({})
    setIsForgotDialogVisible(false)
    errors.emailAddress = ''
  }

  const footer = (
    <div>
      <Button label="Send" icon="pi pi-check" onClick={(e) => forgotPasswordSubmit(e)} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => cancelDailogheader()} />
    </div>
  )

  const forgotPasswordSubmit = (e) => {
    e.preventDefault()
    if (e) {
      e.preventDefault()
      setErrors(userValidation.forgotPasswordValidation(emailAddress))
    }
    if (emailAddress && errors.emailAddress === '') {
      forgotPassword(emailAddress)
      setIsForgotDialogVisible(false)
    }
  }

  const showForgotPassword = () => {
    inputs['emailAddress'] = ('')
    errors.emailAddress = ''
    setIsForgotDialogVisible(true)

  }
  return (
    <div className="p-grid login">
      <div className="p-col-4 login--wrapperLeft">
        <div className="p-col-align-center">
          <h3>WALLSTREET MAPS</h3>
          <p>Administrator</p>
        </div>
      </div>
      <div className="p-col-8 p-col-align-center login--wrapperRight">
        <div className="login--holder">
          <h4>Welcome Administrator</h4>
          <form name="form" onSubmit={handleSubmit}>
            <InputText value={username} name="username" className="login--input" placeholder="Username" type="email" onChange={onChange} />
            {errors.userName && (
              <p className='space-danger'>{errors.userName}</p>
            )}
            <Password value={password} name="password" className="login--input" placeholder="Password" onChange={onChange} feedback={false} />
            {errors.password && (
              <p className='space-danger'>{errors.password}</p>
            )}
            <div className="login--actionSec">
              <Button label="Login" className="p-button-raised p-button-rounded login--actionSec--loginBtn" onClick={() => handleSubmit} />
            </div>
            <div className="login--actionSec">
              <span className="login--actionSec--forgot" onClick={() => showForgotPassword()} >Forgot Password? </span>
            </div>
          </form>
          <Dialog header="Forgot Password" footer={footer} visible={isForgotDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsForgotDialogVisible(false)}>
            <div>Please enter your email address to reset password:
              <InputText name="emailAddress" type="email" className="login--input" value={emailAddress} onChange={onEmailChange} />
              {errors.emailAddress && (
                <p className='space-danger'>{errors.emailAddress}</p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  )
}
export default LoginComponent


LoginComponent.propTypes = {
  user: PropTypes.object,
  authentication: PropTypes.object,
  login: PropTypes.func,
  forgotPassword: PropTypes.func,
}
